import { ApiService }      from '../../app-lite/api/api.service';
import { PartstechService }   from '../../app-lite/partstech/partstech.service';
import { PurchaseOrderModel } from './models/purchase-order';
import { SessionService }  from '../../app-lite/sessions/session.service';
import { TableService }       from '../../app-lite/table/table.service';

import OpenOrdersHtml    from './purchase-order.open.html';
import PurchaseOrderHtml from './purchase-order.html';

export function PurchaseOrdersStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller: 'purchaseOrderCtrl',
    name      : 'app.purchase-order',
    params    : {
      acquisition_order_id: { squash: true, value: null },
      id                  : { squash: true, value: null },
      vendor_id           : { squash: true, value: null }
    },
    templateUrl: PurchaseOrderHtml,
    url        : '/:vendor_id/purchase_order/:id/:acquisition_order_id',
    resolve    : {
      company   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      dealership: ( sessionObjAPI : SessionService, workshopAPI : ApiService ) : ng.IPromise<any> | null =>
        sessionObjAPI.company().has_dealership
          ? workshopAPI.get('/dealership_setting')
          : null,
      partstech_orders: (
        $q          : ng.IQService,
        $rootScope  : any,
        $stateParams: ng.ui.IStateParamsService,
        partstechApi: PartstechService
      ) : ng.IPromise<Array<PurchaseOrderModel>> => {
        return $rootScope.Company.hasIntegration('partstech') && $stateParams.id
          ? partstechApi.getOrders({ id: $stateParams.id })
          : $q.when([]);
      },
      purchase_order: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.id
          ? workshopAPI.get('/purchase_order', $stateParams.id)
          : '',
      vendor: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService) : ng.IPromise<any> | string =>
        $stateParams.vendor_id
          ? workshopAPI.get('/vendor', $stateParams.vendor_id)
          : ''
    }
  })
  .state({
    controller : 'OpenOrdersCtrl',
    name       : 'app.open-orders',
    templateUrl: OpenOrdersHtml,
    url        : '/open_orders',
    resolve    : {
      orders: ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('openOrders');

        return workshopAPI.get('/dashboard/open_orders_list', [
          cache.paging.pageSize   || 10,
          0,
          cache.sorting.field     || 'order_number',
          cache.sorting.direction || 'asc'
        ]);
      }
    }
  });
};